import rsc from "@Config/resources"

export const values = [
  {
    name: "Id",
    value: "",
    filterType: "singleValue",
    resourceIds: [rsc.CmFilterCmId, rsc.MASSIVE_LOAD_FILTER_MASSIVE_LOAD_ID],
  },
]